import React, { useState } from 'react';
import imgVectorStroke from '../../assets/sections/321c9b5a707885092ab66bbeb813697b15e373cf.svg';
import imgVectorStroke1 from '../../assets/sections/de1b27944d8f96be116e49ffc47d6877ff61e3fa.svg';
import imgImage7 from '../../assets/sections/00d14b12320dbdbd6d51dff62ccdcdf99257c5cf.png';
import imgImage30 from '../../assets/sections/27a0742b9b2532a8169f65dcbcfda7d38005f884.png';
import imgPolygon14 from '../../assets/sections/f44f01b47759298393500618aedc83b2673b7047.png';
import imgEllipse2 from '../../assets/sections/a836766bf280c47975ca8984cd528c0bf25470ec.svg';
import imgGroup17 from '../../assets/sections/4b092af9b6cfa5000fdd07da2ffe4c4499f08f44.svg';
import imgGroup19 from '../../assets/sections/8fa60bbedd9dd625666db57d5f1b77995bb5e3b3.svg';

// Mentor portrait images
import imgImage32 from '../../assets/sections/86c9177185be0993ab007927efb3fb4d272fe2b5.png';
import imgImage48 from '../../assets/sections/7ed256e4d8e6608acf8175678bbf5c44fd8960b0.png';
import imgImage49 from '../../assets/sections/3c307e2ee3710d1b8669ca5a33df3162aa60e95b.png';
import imgImage50 from '../../assets/sections/fe89bd1289b0b2818e4744ef9f582095b6eddeb9.png';
import imgImage51 from '../../assets/sections/c1f071eea81180dcc0a03f74526758b794074034.png';
import imgImage52 from '../../assets/sections/01277479a9d82ae37ab1670341f40b239e3fff45.png';
import imgImage53 from '../../assets/sections/4cfdd4fd0e0257131f2910cca2d6081910335d93.png';
import imgImage54 from '../../assets/sections/6b00420ae17d2f56b0913a304bd419a5eac6c4f0.png';
import imgImage55 from '../../assets/sections/a3cd593d8a690ac7ff11ba0291133940cd1f4180.png';
// imgImage56 is a mask SVG not needed in carousel render
import imgImage57 from '../../assets/sections/126a4c01e75efbe35b6eab195a1ead4faf3557ea.png';
import imgImage58 from '../../assets/sections/42c9f06df03a14d4c1a3e1ecc6c9fc72f6f510f3.png';
import imgImage59 from '../../assets/sections/f3f652a24a803d2580daed79cc76c258290b8b08.png';
import imgImage60 from '../../assets/sections/94cb0d3d051e4250f63a94f5777ce2624d32f3a5.png';
// imgImage61 is a mask SVG not needed in carousel render
import imgImage62 from '../../assets/sections/177696962cf41cdbd00e7310b3f0dc12df243e19.png';
import imgImage63 from '../../assets/sections/97a1dab9f4c3c831ab6ac3c934939fac0e37a712.png';
// imgImage64 is a mask SVG not needed in carousel render
import imgImage65 from '../../assets/sections/ba861d5d36165d3900b8f11bd0cb465a827c75c8.png';
import imgImage66 from '../../assets/sections/7efa75f5412401ec23c4a2b7ffaf0d3f95c29337.png';
import imgImage67 from '../../assets/sections/4e844125a3d69fc43003588ccee41f501239e7ce.png';
// imgImage68 is a mask SVG not needed in carousel render
import imgImage69 from '../../assets/sections/9ce3fa96f453c17cc188aca195bebaf0453ff3de.png';
import imgImage70 from '../../assets/sections/52cf40adca5da9f459c6bd0c18292c14ffd3ac6f.png';
import imgImage71 from '../../assets/sections/a5bdfdc37eac20c9f0cdb90e2c1ca52384581ff3.png';
import imgImage72 from '../../assets/sections/0a069a3eb205e91a1707423baf33c0218ed276a6.png';
import imgImage73 from '../../assets/sections/fb43a310b140d170533fd93f7c23601de326b6d2.png';
import imgImage74 from '../../assets/sections/9398d93978cfce0307db7042a48219b43e666bde.png';
// imgImage75 is a mask SVG not needed in carousel render
import imgImage76 from '../../assets/sections/4becad2e03a77d42cbce3d8ef9253a09214c4b27.png';
import imgImage77 from '../../assets/sections/53c6fe752d8b535368de9695a0a26a116f0f569c.png';
import imgImage78 from '../../assets/sections/2a0c41560a405b6c0a5d543b0bad94235847946d.png';
import imgImage79 from '../../assets/sections/0e526ef0607f3b0d1e8924d7ae400e0a36717e40.png';
import imgImage80 from '../../assets/sections/f17b79c99e97811fd1788aac2079111ed16828b8.png';
import imgImage81 from '../../assets/sections/53da5e83fff222ee6e40a2214ea2280276d62ca4.png';
import imgImage82 from '../../assets/sections/a58c25d1e51d68e4913ecfb9ce34bd60fc2d6631.png';
import imgImage83 from '../../assets/sections/fcf1683b7b13e08d74c5590f62924a58b0daf69c.png';
import imgImage84 from '../../assets/sections/756c4ff2c7848de5786ce1f6d540ee7a07ef07ba.png';
import imgImage85 from '../../assets/sections/2d682714cd59e3835346f97e3b21374fdd12c051.png';
import imgImage46 from '../../assets/sections/7a330330e5a166bfead951a710d5abdfb78e7389.png';
import imgImage47 from '../../assets/sections/f0de9f82d3d05ce5ce7d239dafc7149c10ab55ce.png';
import imgImage86 from '../../assets/sections/fab6836738f4d6f25065aeb6d3010ea0900600c0.png';

function OutlineArrowsAltArrowRight({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[72px]"}>
      <div className="absolute inset-[17.71%_34.37%]">
        <img alt="" className="absolute block max-w-none size-full" src={imgVectorStroke} />
      </div>
    </div>
  );
}

function OutlineArrowsAltArrowLeft({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[72px]"}>
      <div className="absolute inset-[17.71%_34.37%_17.71%_34.38%]">
        <img alt="" className="absolute block max-w-none size-full" src={imgVectorStroke1} />
      </div>
    </div>
  );
}

// All mentors extracted from Figma node 2003:16
const mentors = [
  { name: 'Nguyễn Thị Huyền Trang', title: 'Chuyên viên tuyển dụng', photo: imgImage32 },
  { name: 'Lê Thị Bích diệp', title: 'Chuyên viên tuyển dụng', photo: imgImage46 },
  { name: 'Phan thị hạ', title: 'Founder & CEO', photo: imgImage47 },
  { name: 'Nguyễn Thị Mai Phương ', title: 'Chuyên viên tuyển dụng', photo: imgImage86 },
  { name: 'Bế Hồng Nhung', title: 'Talent Acquisition ', photo: imgImage48 },
  { name: 'Trần Bảo Tâm', title: 'Chuyên viên tuyển dụng', photo: imgImage83 },
  { name: 'Võ Thị Lê Na', title: 'TP Tuyển dụng Nhân sự', photo: imgImage84 },
  { name: 'Nguyễn Thị Thảo', title: 'Cố vấn chuyên môn', photo: imgImage85 },
  { name: 'Đỗ Trung Khánh', title: 'Mentor', photo: imgImage49 },
  { name: 'Nguyễn Thị Kim Hoa', title: 'HRBP', photo: imgImage50 },
  { name: 'Nguyễn Như Quỳnh', title: ' CEO', photo: imgImage51 },
  { name: 'Nguyễn Thùy Linh ', title: 'Trưởng phòng Tuyển dụng và Thu hút nhân tài', photo: imgImage52 },
  { name: 'Phạm Minh Phong', title: 'HRBP Manager', photo: imgImage53, photoImg: imgImage54 },
  { name: 'Trần Vũ Thái', title: 'Mentor', photo: imgImage80 },
  { name: 'Nguyễn Thị Chinh', title: 'Talent Acquisition', photo: imgImage81 },
  { name: 'Lam Bình', title: 'Nhân sự tổng hợp', photo: imgImage82 },
  { name: 'Nguyễn Ngọc Bảo Lâm', title: 'Human Resources Supervisor', photo: imgImage55 },
  { name: 'Nguyễn Thành Nhân', title: 'OD expert', photo: imgImage57 },
  { name: 'Nguyễn Thị Thanh Thanh', title: 'HRM', photo: imgImage58 },
  { name: 'Nguyễn Thị Thoa', title: 'Trưởng phòng Nhân sự', photo: imgImage79 },
  { name: 'Khuất Thị Hằng', title: 'HRBP', photo: imgImage77 },
  { name: 'Vương Yến Nhi', title: 'Chuyên viên Tuyển dụng', photo: imgImage78 },
  { name: 'Trần Thị Mai Hương', title: 'Chuyên viên Nhân sự tổng hợp', photo: imgImage82 },
  { name: 'Bùi Khánh Vân', title: 'HRBP', photo: imgImage59 },
  { name: 'Nguyễn Lan Anh', title: 'Trưởng phòng Nhân sự', photo: imgImage60 },
  { name: 'Nguyễn Thị Thạ', title: 'Mentor', photo: imgImage62 },
  { name: 'Đào Việt Bách', title: 'Founder & CEO', photo: imgImage63 },
  { name: 'Phan Đức Lương', title: 'Chuyên gia tư vấn giải pháp tuyển dụng', photo: imgImage65 },
  { name: 'Nguyễn Văn Huấn', title: 'CEO', photo: imgImage66 },
  { name: 'Đặng Thị Luyến', title: 'HRM', photo: imgImage67 },
  { name: 'Nguyễn Thị Dung', title: 'HR Manager', photo: imgImage69 },
  { name: 'Lê Đình Hùng', title: 'PGD Nhân sự.', photo: imgImage70 },
  { name: 'Trần Cúc Phương', title: 'Cố vấn chuyên môn', photo: imgImage71 },
  { name: 'Trương Thị Thu Hương', title: 'Trưởng nhóm Tuyển dụng & Phát triển thương hiệu Tuyển dụng', photo: imgImage72 },
  { name: 'Hà Tường Vi', title: 'Trưởng nhóm Tạo nguồn và Thương hiệu tuyển dụng', photo: imgImage73 },
  { name: 'Nguyễn Thị Bích Ngọc', title: 'TA leader', photo: imgImage74 },
  { name: 'Kiều Thị Bích Nguyệt', title: 'Chuyên viên HCNS', photo: imgImage76 },
];

export default function Mentor() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? mentors.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === mentors.length - 1 ? 0 : prev + 1));
  };

  const currentMentor = mentors[currentIndex];

  return (
    <div className="relative w-[1920px] h-[1080px]" data-node-id="199:252">
      <div className="absolute h-[1082px] left-0 top-0 w-[1924.557px]" data-name="image 7" data-node-id="199:253">
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
          <img alt="" className="absolute max-w-none object-cover size-full" src={imgImage7} />
          <div className="absolute bg-[#002e2a] inset-0" />
        </div>
      </div>
      <div className="absolute h-[635px] left-[-299px] top-[-241px] w-[1112px]" data-node-id="201:389">
        <div className="absolute inset-[-107.72%_-61.51%]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse2} />
        </div>
      </div>
      <div className="absolute contents left-[-155px] top-[173px]" data-node-id="223:75">
        <div className="absolute h-[553px] left-[-155px] top-[173px] w-[1144px]" data-name="image 30" data-node-id="199:380">
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img alt="" className="absolute h-[110.87%] left-[-0.01%] max-w-none top-0 w-[100.02%]" src={imgImage30} />
          </div>
        </div>
        <div className="cursor-pointer absolute bg-[#ff3535] content-stretch flex h-[80px] items-center justify-center left-[134px] px-[19px] py-[14px] rounded-[16px] shadow-[23px_28px_84px_0px_rgba(0,0,0,0.1)] top-[780px] w-[245px]" data-name="Discount container" data-node-id="199:377"
          onClick={() => {
            window.open("https://forms.gle/TWNB2gjgp9Ar9BG19", '_blank')
          }}
        >
          <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[21px] text-center text-white whitespace-nowrap" data-node-id="199:378">
            GỬI CV NGAY
          </p>
        </div>
        <p className="absolute font-['Alexandria',sans-serif] font-bold leading-[normal] left-[calc(50%-826px)] text-[#e9fffa] text-[39px] top-[655px] uppercase whitespace-nowrap" data-node-id="223:117">
          Dàn mentor nhiều năm kinh nghiệm
        </p>
      </div>
      <div className="absolute h-0 left-[784px] top-[992px] w-[356px]" data-node-id="199:383">
        <div className="absolute inset-[-48px_-13.48%]">
          <img alt="" className="block max-w-none size-full" src={imgGroup17} />
        </div>
      </div>
      {/* Carousel mentor card - polygon frame */}
      <div className="absolute h-[455px] left-[1121px] top-[295px] w-[534px]" data-node-id="201:416">
        <img alt="" className="absolute block max-w-none size-full" height="455" src={imgPolygon14} width="534" />
      </div>
      {/* Mentor photo - bottom aligned with hexagon bottom (polygon top=295 + h=455 = 750px; photo h=585 so top=750-585=165px) */}
      <div className="absolute h-[585px] left-[1230px] top-[165px] w-[362px]" data-name="image 32" data-node-id="201:408">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={currentMentor.photo} />
      </div>
      <div className="absolute h-0 left-[1206px] top-[750px] w-[356px]" data-node-id="201:400">
        <div className="absolute inset-[-58px_-16.29%]">
          <img alt="" className="block max-w-none size-full" src={imgGroup19} />
        </div>
      </div>
      {/* Mentor name card - centered under hexagon center (polygon left=1121 + w/2=267 = 1388px) */}
      <div className="absolute content-stretch flex flex-col gap-[12px] items-center justify-center px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[750px]" data-node-id="201:391"
        style={{ left: '1388px', transform: 'translateX(-50%)', minWidth: '420px' }}
      >
        <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-bold leading-[36px] relative shrink-0 text-[#d4f8eb] text-[28px] uppercase text-center whitespace-nowrap" data-node-id="201:392">
          {currentMentor.name}
        </p>
        <p className="font-['Alexandria',sans-serif] font-medium leading-[36px] relative shrink-0 text-[#d4f8eb] text-[24px] text-center" data-node-id="201:394">
          {currentMentor.title}
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      {/* Carousel navigation arrows */}
      <div className="absolute contents left-[1025px] top-[486px]" data-node-id="201:415">
        <button onClick={handlePrev} className="cursor-pointer absolute left-[1025px] overflow-clip size-[72px] top-[486px] bg-transparent border-none p-0">
          <OutlineArrowsAltArrowLeft className="overflow-clip relative size-[72px]" />
        </button>
        <button onClick={handleNext} className="cursor-pointer absolute left-[1659px] overflow-clip size-[72px] top-[486px] bg-transparent border-none p-0">
          <OutlineArrowsAltArrowRight className="overflow-clip relative size-[72px]" />
        </button>
      </div>

    </div>
  );
}
